var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoShadow = function SvgVideoShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 189,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 300 189"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-shadow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#video-shadow_svg__b)",
    fillOpacity: 0.2,
    d: "M18.484 30.963a5.03 5.03 0 0 1 1.377-3.087L38.111 8.76c3.135-3.285 8.675-1.066 8.675 3.476v164.402a5.034 5.034 0 0 1-5.034 5.034H12.226a5.034 5.034 0 0 1-5.02-5.424z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-shadow_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23221C",
    fillOpacity: 0.1,
    d: "M44.48 181.761c-2.366-2.152-.843-6.089 2.355-6.089h245.548c2.768 0 4.44 3.06 2.947 5.389a3.5 3.5 0 0 1-2.947 1.611H46.835a3.5 3.5 0 0 1-2.355-.911"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-shadow_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23221C",
    fillOpacity: 0.2,
    d: "M44.3 179.584c-2.326-3.337.062-7.912 4.13-7.912h242.875c3.574 0 6.009 3.619 4.664 6.93l-.379.932a5.04 5.04 0 0 1-4.664 3.138H49.079a5.03 5.03 0 0 1-4.13-2.156z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "video-shadow_svg__a",
    width: 53.978,
    height: 188.864,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1987_14",
    stdDeviation: 3.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video-shadow_svg__c",
    width: 255.438,
    height: 9.877,
    x: 41.89,
    y: 174.234,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1987_14",
    stdDeviation: 0.719
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video-shadow_svg__d",
    width: 255.834,
    height: 13.877,
    x: 41.948,
    y: 170.234,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1987_14",
    stdDeviation: 0.719
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "video-shadow_svg__b",
    x1: 41.072,
    x2: 19.024,
    y1: 87.348,
    y2: 85.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23221C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2DCB0",
    stopOpacity: 0
  })))));
};
export default SvgVideoShadow;